'use client';

import React from 'react';
import styles from './Team.module.scss';
import Button, { ButtonType } from '../Button/Button';
import { Link } from '@/i18n/navigation';
import Img from '../Img';

interface IButton {
  id: number,
  title: string,
  type: ButtonType,
  link: string
}

type Image = {
  id: number;
  alternativeText: string | null;
  width: number;
  height: number;
  url: string;
};

interface TeamMember {
  id: number;
  name: string;
  position: string;
  description: string;
  avatar: Image;
  socials: {
    id: number;
    link: string;
    icon: Image;
  }[]
}

interface ITeam {
  title: string;
  subtitle: string;
  description: string;
  button: IButton;
  team: TeamMember[];
}

export default function Team({ data }: { data: ITeam }) {
  return (
    <section className={styles.team}>
      <div className={styles.left}>
        <p className={styles.tagline}>{data.subtitle}</p>
        <div className={styles.textContent}>
          <h2 className={styles.title}>{data.title}</h2>
          <p className={styles.text}>{data.description}</p>
        </div>
        {data.button && (
        <Button
          fitContent
          href={data.button.link}
          type={data.button.type}
          className={styles.cta}
        >
          {data.button.title}
        </Button>
        )}
      </div>

      <ul className={styles.right}>
        {data.team.map((member) => (
          <li
            key={member.id}
            className={styles.card}
          >
            <div className={styles.imageWrapper}>
              <Img
                className={styles.avatar}
                height={200}
                width={200}
                local={!member.avatar?.url}
                src={member.avatar?.url || '/team-placeholder.png'}
                alt={member.avatar?.alternativeText || ''}
              />
            </div>
            <div className={styles.content}>
              <header>
                <h3 className={styles.name}>{member.name}</h3>
                <p className={styles.role}>{member.position}</p>
              </header>
              <p className={styles.desc}>{member.description}</p>
              <ul className={styles.socials}>
                {member.socials.map((social) => (
                  <li key={social.id}>
                    <Link
                      href={social.link}
                      target='_blank'
                    >
                      <Img
                        src={social.icon.url || ''}
                        alt={social.icon.alternativeText || ''}
                        height={24}
                        width={24}
                      />
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </li>
        ))}
      </ul>
    </section>
  );
}
